import { render } from "./HomeMenu.vue?vue&type=template&id=623a643c&scoped=true"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"

import "./HomeMenu.vue?vue&type=style&index=0&id=623a643c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623a643c"],['__file',"src/views/h5/common/home/HomeMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "623a643c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('623a643c', __exports__)) {
    api.reload('623a643c', __exports__)
  }
  
  module.hot.accept("./HomeMenu.vue?vue&type=template&id=623a643c&scoped=true", () => {
    api.rerender('623a643c', render)
  })

}


export default __exports__